import { useSessionStorage } from 'marketing-site/src/library/hooks/use-session-storage'
import React, { useEffect } from 'react'
import { IPageBehaviorComponentProps } from './PageBehaviors'
import { getSearchParameters, IObject } from 'marketing-site/src/library/utils'

export default function InboundForm({ children }: IPageBehaviorComponentProps): React.ReactElement {
  const [referralCompany, setReferralCompany] = useSessionStorage<IObject<string> | null>(
    'referral-company',
    null,
  )
  const collectReferralData = () => {
    //Process data from url
    //Potentially to request encrypted data parsing via endpoint
    const params = getSearchParameters()
    setReferralCompany(params)
  }

  useEffect(() => {
    if (referralCompany) setReferralCompany(null)
    collectReferralData()
  }, [])

  return <>{children}</>
}
